import axios from 'axios'
import moment from 'moment'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'
import { salvarCacheViagens, salvarCacheCidades, salvarCacheMapa, salvarCacheFormasPagamento, salvarCacheItinerariosAbertosVendaUrbana } from '../../util/offlineStorage'

export default async function carregarItinerariosOffline(empresaId, data, origemIdSelecionada, destinoIdSelecionado) {
  const dataFormatada = data || moment().format('YYYY-MM-DD')

  const respRotas = await axios.get(
    `${URL}/rota/empresa/${empresaId}/todas-rotas`,
    SLOW_REQUEST_CONFIG
  )

  const rotas = Array.isArray(respRotas.data) ? respRotas.data : []

  const cidadesMap = new Map()
  const pares = new Map()

  rotas.forEach(rota => {
    if (rota.cidadeOrigem) {
      cidadesMap.set(rota.cidadeOrigem.id, rota.cidadeOrigem)
    }
    if (rota.cidadeDestino) {
      cidadesMap.set(rota.cidadeDestino.id, rota.cidadeDestino)
    }
    if (rota.trechosDto) {
      rota.trechosDto.forEach(trecho => {
        if (trecho.cidadeDestino) {
          cidadesMap.set(trecho.cidadeDestino.id, trecho.cidadeDestino)
        }
      })
    }
    if (rota.cidadeOrigem && rota.cidadeDestino) {
      const chave = `${rota.cidadeOrigem.id}_${rota.cidadeDestino.id}`
      if (!pares.has(chave)) {
        pares.set(chave, { origemId: rota.cidadeOrigem.id, destinoId: rota.cidadeDestino.id })
      }
    }
  })

  salvarCacheCidades(empresaId, Array.from(cidadesMap.values()))

  try {
    const urlFormas = `${URL}/formapagamento/empresa/${empresaId}/pagamentos-desativados`
    const respFormas = await axios.get(urlFormas, SLOW_REQUEST_CONFIG)
    if (respFormas.data) {
      salvarCacheFormasPagamento(empresaId, respFormas.data)
    }
  } catch (e) {
    console.warn('carregarItinerariosOffline: falha ao carregar formas de pagamento', e)
  }

  try {
    // Escopado por empresaId (URL e chave de cache) — não deve conter itinerários de outras empresas
    const urlItinerariosVendaUrbana = `${URL}/vendas-urbanas/empresa/${empresaId}/itinerarios-abertos`
    const respItinerariosVendaUrbana = await axios.get(urlItinerariosVendaUrbana, SLOW_REQUEST_CONFIG)
    if (respItinerariosVendaUrbana.data) {
      salvarCacheItinerariosAbertosVendaUrbana(empresaId, respItinerariosVendaUrbana.data)
    }
  } catch (e) {
    console.warn('carregarItinerariosOffline: falha ao carregar itinerários de venda urbana', e)
  }

  if (origemIdSelecionada && destinoIdSelecionado) {
    const chaveSelecionada = `${origemIdSelecionada}_${destinoIdSelecionado}`
    if (!pares.has(chaveSelecionada)) {
      pares.set(chaveSelecionada, { origemId: origemIdSelecionada, destinoId: destinoIdSelecionado })
    }
  }

  let carregados = 0
  const total = pares.size
  const mapasCacheados = new Set()

  for (const [, par] of pares) {
    try {
      const url = `${URL}/passagem/origem/${par.origemId}/destino/${par.destinoId}/dataIda/${dataFormatada}/empresa/${empresaId}?buscaTipoVeiculo=TODOS`
      const resp = await axios.get(url, SLOW_REQUEST_CONFIG)
      if (resp.data) {
        salvarCacheViagens(empresaId, par.origemId, par.destinoId, dataFormatada, resp.data)

        const viagens = [
          ...(resp.data.passagensIda || []),
          ...(resp.data.passagensRetorno || [])
        ]
        for (const viagem of viagens) {
          if (!viagem.idItinerario) continue
          const chaveMapa = `${viagem.idItinerario}_${par.origemId}_${par.destinoId}_${viagem.tipoVeiculo || 'DEFAULT'}`
          if (mapasCacheados.has(chaveMapa)) continue
          mapasCacheados.add(chaveMapa)
          try {
            const urlMapa = `${URL}/mapas-veiculos/itinerario/${viagem.idItinerario}/origem/${par.origemId}/destino/${par.destinoId}?categoria=${viagem.tipoVeiculo || ''}`
            const respMapa = await axios.get(urlMapa, SLOW_REQUEST_CONFIG)
            if (respMapa.data) {
              salvarCacheMapa(viagem.idItinerario, par.origemId, par.destinoId, viagem.tipoVeiculo, respMapa.data)
            }
          } catch (e) {
            console.warn('carregarItinerariosOffline: falha ao carregar mapa', chaveMapa, e)
          }
        }
      }
      carregados++
    } catch (e) {
      console.warn('carregarItinerariosOffline: falha ao carregar rota', par, e)
    }
  }

  return { carregados, total }
}
